module.exports = __webpack_public_path__ + "img/first_step.f28697ce.png";